import { ImageIcon } from "lucide-react";
import { Skeleton } from "../../components/ui/skeleton/skeleton";
import { cn } from "../../lib/utils";
import { useFile } from "../../queries/documents/use-file";

export interface ImageFileProps
  extends React.HTMLAttributes<Omit<HTMLImageElement, "src">> {
  fileId: string;
}

export function ImageFile({ fileId, ...props }: ImageFileProps) {
  const { fileUrl, isPending, error } = useFile(fileId);

  if (isPending)
    return <Skeleton className={cn("h-full w-full", props.className)} />;

  if (error || !fileUrl) return <ImageIcon className={props.className} />;

  return <img src={fileUrl} {...props} />;
}
